import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreadcrumbPart } from '../../models/breadcrumb-part.model';

@Component({
    selector: 'ca-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
    @Input() breadcrumbParts: Array<BreadcrumbPart>;
}
